<template>
  <div class="elevation-5 signing">
    <div class="logo-wrapper">
      <div class="logo"></div>
    </div>
    <div class="sign-box pb-5">
      <div class="input-box">
        <h1 class="token-invalid">Email link invalid</h1>
      </div>
    </div>
    <p class="copyright">COPYRIGHT ⓒImGATE ALL RIGHTS RESERVED.</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    mounted() {
      console.log('Email link invliad...');
    },
  };
</script>

<style lang="scss" scoped>
.token-invalid {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/signing/EmailInvalid.vue